import React, { Fragment } from 'react'
import { View, Text, StyleSheet } from "@react-pdf/renderer"
const Policy = ({ data }) => {
    const styles = StyleSheet.create({
        container: {
            width: "100%",
            flexDirection: "column",
            paddingLeft: '15px',
        },
        text: {
            color: "#454545",
            fontSize: 11,
            fontWeight: "bold",
            marginBottom: "4px",
        }
    })
    return (
        <Fragment>
            <View style={styles.container}>
                <Text style={styles.text}>1. Receipt limit exceeded</Text>
                <Text style={styles.text}>2. Amount limit exceeded</Text>
                <Text style={styles.text}>3. Description is missing</Text>
            </View>
        </Fragment>
    )
}

export default Policy;